import { render, staticRenderFns } from "./CollectPage.vue?vue&type=template&id=0e3210ee&scoped=true"
import script from "./CollectPage.vue?vue&type=script&lang=js"
export * from "./CollectPage.vue?vue&type=script&lang=js"
import style0 from "./CollectPage.vue?vue&type=style&index=0&id=0e3210ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3210ee",
  null
  
)

export default component.exports